const bookingform = [
  {
    id: 1,
    field: "date",
    label: "Date",
    type: "date",
    required: true
  },
  {
    id: 2,
    field: "time",
    label: "Time",
    type: "time",
    required: true
  },
  {
    id: 3,
    field: "guests",
    label: "Number Of Guests",
    type: "number",
    required: true
  },
  {
    id: 4,
    field: "name",
    label: "Name",
    type: "text",
    required: true
  },
  {
    id: 5,
    field: "phone",
    label: "Phone",
    type: "text",
    required: true
  },
  {
    id: 6,
    field: "message",
    label: "Questions Or Comments",
    type: "textarea",
    required: true
  }
];

export default bookingform;